import React, { useState, useCallback, memo } from 'react';
import { expensTableSTyle as styles } from '../ExpenseStatement/ExpenseStatementTable/expenseTableStyle.js';

const PAGE_SIZE = 6;

const MonthColumn = memo(({ monthData, isExpanded, isOutFlowExpanded, isLoadingInflow, isLoadingOutflow, colWidth }) => {
  const formatCurrency = (amount) => {
    if (amount === 0) return '₹0';
    if (amount < 0) return `-₹${Math.abs(amount).toLocaleString('en-IN')}`;
    return `₹${amount.toLocaleString('en-IN')}`;
  };

  const neg = (val) => val < 0 ? styles.dataCellNegative : {};

  return (
    <div style={{ ...styles.monthColumn, width: colWidth }}>
      <div style={{ ...styles.dataCell, ...neg(monthData?.cashAtBeginning) }}>
        {formatCurrency(monthData?.cashAtBeginning ?? 0)}
      </div>

      <div style={{ ...styles.dataCell, ...styles.dataCellThirdParty, ...neg(monthData?.cashInflow) }}>
        {formatCurrency(monthData?.cashInflow ?? 0)}
      </div>

      {(isExpanded || isLoadingInflow) && (
        <div style={{ ...styles.subDataColumns, ...styles.subCont }}>
          {isLoadingInflow ? (
            <>
              <div style={{ ...styles.subDataCell, background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.5s infinite' }} />
              <div style={{ ...styles.subDataCell, background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.5s infinite' }} />
              <div style={{ ...styles.subDataCell, background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.5s infinite' }} />
              <div style={{ ...styles.subDataCell, background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.5s infinite' }} />
              <div style={{ ...styles.subDataCell, background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.5s infinite' }} />
              <div style={{ ...styles.subDataCell, background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.5s infinite' }} />
            </>
          ) : (
            <>
              <div style={{ ...styles.subDataCell, ...neg(monthData?.processingFees) }}>{formatCurrency(monthData?.processingFees ?? 0)}</div>
              <div style={{ ...styles.subDataCell, ...neg(monthData?.interest) }}>{formatCurrency(monthData?.interest ?? 0)}</div>
              <div style={{ ...styles.subDataCell, ...neg(monthData?.firstTranche) }}>{formatCurrency(monthData?.firstTranche ?? 0)}</div>
              <div style={{ ...styles.subDataCell, ...neg(monthData?.secondTranche) }}>{formatCurrency(monthData?.secondTranche ?? 0)}</div>
              <div style={{ ...styles.subDataCell, ...neg(monthData?.thirdTranche) }}>{formatCurrency(monthData?.thirdTranche ?? 0)}</div>
              <div style={{ ...styles.subDataCell, ...neg(monthData?.penaltyLateFees) }}>{formatCurrency(monthData?.penaltyLateFees ?? 0)}</div>
            </>
          )}
        </div>
      )}

      <div style={{ ...styles.dataCell, ...styles.dataCellThirdParty, ...neg(monthData?.cashOutflow) }}>
        {formatCurrency(monthData?.cashOutflow ?? 0)}
      </div>

      {(isOutFlowExpanded || isLoadingOutflow) && (
        <div style={{ ...styles.subDataColumns, ...styles.subCont }}>
          {isLoadingOutflow ? (
            <>
              <div style={{ ...styles.subDataCell, background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.5s infinite' }} />
              <div style={{ ...styles.subDataCell, background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.5s infinite' }} />
              <div style={{ ...styles.subDataCell, background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.5s infinite' }} />
              <div style={{ ...styles.subDataCell, background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.5s infinite' }} />
              <div style={{ ...styles.subDataCell, background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.5s infinite' }} />
              <div style={{ ...styles.subDataCell, background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.5s infinite' }} />
              <div style={{ ...styles.subDataCell, background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.5s infinite' }} />
              <div style={{ ...styles.subDataCell, background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.5s infinite' }} />
            </>
          ) : (
            <>
              <div style={{ ...styles.subDataCell, ...neg(monthData?.technologyExpense) }}>{formatCurrency(monthData?.technologyExpense ?? 0)}</div>
              <div style={{ ...styles.subDataCell, ...neg(monthData?.thirdPartApi) }}>{formatCurrency(monthData?.thirdPartApi ?? 0)}</div>
              <div style={{ ...styles.subDataCell, ...neg(monthData?.administrativeExpense) }}>{formatCurrency(monthData?.administrativeExpense ?? 0)}</div>
              <div style={{ ...styles.subDataCell, ...neg(monthData?.employeeSalary) }}>{formatCurrency(monthData?.employeeSalary ?? 0)}</div>
              <div style={{ ...styles.subDataCell, ...neg(monthData?.customerAcquisition) }}>{formatCurrency(monthData?.customerAcquisition ?? 0)}</div>
              <div style={{ ...styles.subDataCell, ...neg(monthData?.interestPaid) }}>{formatCurrency(monthData?.interestPaid ?? 0)}</div>
              <div style={{ ...styles.subDataCell, ...neg(monthData?.regulatoryCompliance) }}>{formatCurrency(monthData?.regulatoryCompliance ?? 0)}</div>
              <div style={{ ...styles.subDataCell, ...neg(monthData?.provisioning) }}>{formatCurrency(monthData?.provisioning ?? 0)}</div>
            </>
          )}
        </div>
      )}

      <div style={{
        ...styles.totalCell,
        background: 'linear-gradient(135deg,rgb(255,255,255) 0%,rgb(255,255,255) 100%)',
        borderTop: '0px solid #34d399',
        color: '#006580',
        ...neg(monthData?.netCashflow),
      }}>
        {formatCurrency(monthData?.netCashflow ?? 0)}
      </div>
    </div>
  );
});

const CashflowStatementTable = ({ item = [], productName }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOutFlowExpanded, setIsOutFlowExpanded] = useState(false);
  const [isLoadingInflow, setIsLoadingInflow] = useState(false);
  const [isLoadingOutflow, setIsLoadingOutflow] = useState(false);
  const [colPage, setColPage] = useState(0);

  const totalCols = item.length;
  const totalPages = Math.max(1, Math.ceil(totalCols / PAGE_SIZE));
  const safePage = Math.min(colPage, totalPages - 1);
  const visibleItem = item.slice(safePage * PAGE_SIZE, safePage * PAGE_SIZE + PAGE_SIZE);

  const toggleExpansion = useCallback(() => {
    if (!isExpanded) {
      setIsLoadingInflow(true);
      setTimeout(() => { setIsExpanded(true); setIsLoadingInflow(false); }, 300);
    } else { setIsExpanded(false); }
  }, [isExpanded]);

  const toggleOutFlowExpansion = useCallback(() => {
    if (!isOutFlowExpanded) {
      setIsLoadingOutflow(true);
      setTimeout(() => { setIsOutFlowExpanded(true); setIsLoadingOutflow(false); }, 300);
    } else { setIsOutFlowExpanded(false); }
  }, [isOutFlowExpanded]);

  const formatMonth = useCallback((dateString) => {
    const date = new Date(dateString);
    const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return `${monthNames[date.getMonth()]} ${date.getFullYear().toString().slice(-2)}`;
  }, []);

  const colWidth = `calc(100% / ${visibleItem.length || 1})`;

  const navBtnBase = {
    width: '32px', height: '32px', borderRadius: '8px',
    border: '1px solid rgba(226,232,240,0.8)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '16px', cursor: 'pointer', transition: 'all 0.2s ease',
    background: '#fff', color: '#1e293b',
  };
  const navBtnDisabled = { ...navBtnBase, background: '#f1f5f9', color: '#94a3b8', cursor: 'not-allowed' };

  const SkeletonLoader = ({ count }) => (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          style={{
            ...styles.subRow,
            background: 'linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 1.5s infinite',
          }}
        />
      ))}
      <style>{`
        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
    </>
  );

  return (
    <div style={styles.container}>
      <div style={{
        ...styles.expenseTableContainer,
        borderRadius: "16px",
        border: "1px solid rgba(226, 232, 240, 0.8)",
        overflow: "hidden",
      }}>
        {/* Header */}
        <div style={{
          width: '100%',
          background: 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)',
          padding: '16px 20px',
          color: 'white',
          textAlign: 'center',
          fontSize: '16px',
          fontWeight: '600',
          letterSpacing: '0.5px',
        }}>
          {productName ?? ''}
        </div>

        <div style={{ ...styles.tableContainer, overflow: "auto", border: "none", borderRadius: 0 }}>
          {/* Fixed Left Column */}
          <div style={styles.leftColumn}>
            <div style={{ ...styles.headerCell, ...styles.leftHeader }}>Cash Flow Statement</div>

            <div style={styles.row}>
              <div style={styles.leftCell}>Cash at begining of the month</div>
            </div>

            <div style={{ ...styles.row, ...styles.expandableRow, cursor: 'pointer' }} onClick={toggleExpansion}>
              <div style={styles.leftCell}>Cash Inflow from</div>
              <div style={{ ...styles.expandIcon, transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                <div style={isExpanded ? styles.arrowUp : styles.arrowDown} />
              </div>
            </div>
            {(isExpanded || isLoadingInflow) && (
              <div style={{ ...styles.subRows, ...styles.subCont }}>
                {isLoadingInflow ? <SkeletonLoader count={6} /> : (
                  <>
                    <div style={styles.subRow}>Processing Fees</div>
                    <div style={styles.subRow}>Interest</div>
                    <div style={styles.subRow}>1st trance</div>
                    <div style={styles.subRow}>2nd trance</div>
                    <div style={styles.subRow}>3rd trance</div>
                    <div style={styles.subRow}>Penalty and Late fee</div>
                  </>
                )}
              </div>
            )}

            <div style={{ ...styles.row, ...styles.expandableRow, cursor: 'pointer' }} onClick={toggleOutFlowExpansion}>
              <div style={styles.leftCell}>Cash Outflow from</div>
              <div style={{ ...styles.expandIcon, transform: isOutFlowExpanded ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                <div style={isOutFlowExpanded ? styles.arrowUp : styles.arrowDown} />
              </div>
            </div>
            {(isOutFlowExpanded || isLoadingOutflow) && (
              <div style={{ ...styles.subRows, ...styles.subCont }}>
                {isLoadingOutflow ? <SkeletonLoader count={8} /> : (
                  <>
                    <div style={styles.subRow}>Technology Expense</div>
                    <div style={styles.subRow}>Third Party API or Outsourcing Costs</div>
                    <div style={styles.subRow}>Administrative expenses</div>
                    <div style={styles.subRow}>Employee salaries and benefits</div>
                    <div style={styles.subRow}>Customer Acquisition Cost</div>
                    <div style={styles.subRow}>Interest Paid for Borrowing</div>
                    <div style={styles.subRow}>Regulatory and Compliance Costs</div>
                    <div style={styles.subRow}>Provisioning and Write-offs</div>
                  </>
                )}
              </div>
            )}

            <div style={styles.totalRow}>Net Cash Flow from Business</div>
          </div>

          {/* Scrollable Right Section (paginated) */}
          <div style={styles.rightColumn}>
            <div style={styles.scrollableHeader}>
              {visibleItem.map((monthData) => (
                <div key={monthData.currentMonth} style={{ ...styles.headerCell, ...styles.monthHeader, width: colWidth }}>
                  {formatMonth(monthData.currentMonth)}
                </div>
              ))}
            </div>

            <div style={styles.scrollableContent}>
              {visibleItem.map((monthData) => (
                <MonthColumn
                  key={monthData.currentMonth}
                  monthData={monthData}
                  isExpanded={isExpanded}
                  isOutFlowExpanded={isOutFlowExpanded}
                  isLoadingInflow={isLoadingInflow}
                  isLoadingOutflow={isLoadingOutflow}
                  colWidth={colWidth}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Bottom pagination bar */}
        {totalPages > 1 && (
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            gap: '12px', padding: '12px 20px',
            borderTop: '1px solid rgba(226, 232, 240, 0.8)',
            background: '#f8fafc',
          }}>
            <button
              onClick={() => setColPage(p => Math.max(0, p - 1))}
              disabled={safePage === 0}
              style={safePage === 0 ? navBtnDisabled : navBtnBase}
            >‹</button>

            <div style={{ display: 'flex', gap: '6px' }}>
              {Array.from({ length: totalPages }).map((_, i) => (
                <button
                  key={i}
                  onClick={() => setColPage(i)}
                  style={{
                    width: '32px', height: '32px', borderRadius: '8px',
                    border: i === safePage ? '1.5px solid #2c3e50' : '1px solid rgba(226,232,240,0.8)',
                    background: i === safePage ? 'linear-gradient(135deg, #2c3e50 0%, #34495e 100%)' : '#fff',
                    color: i === safePage ? '#fff' : '#64748b',
                    fontWeight: i === safePage ? '700' : '500',
                    fontSize: '13px', cursor: 'pointer',
                    transition: 'all 0.2s ease',
                  }}
                >{i + 1}</button>
              ))}
            </div>

            <button
              onClick={() => setColPage(p => Math.min(totalPages - 1, p + 1))}
              disabled={safePage === totalPages - 1}
              style={safePage === totalPages - 1 ? navBtnDisabled : navBtnBase}
            >›</button>
          </div>
        )}

      </div>
    </div>
  );
};

export default CashflowStatementTable;